export const fastTrackMorning = (items) => {
  return !items.some(({ hasSuperPower, expired }) => hasSuperPower && !expired);
};

export const getRandomItem = (arr = []) =>
  arr[Math.floor(Math.random() * arr.length)];
